import { createContext } from 'react'

import type { NewslettersContext as NewslettersContextValue } from '../types'

export const NewslettersContext = createContext<NewslettersContextValue>({
  error: null,
  isLoading: false,
  newsletters: null,
})

/** @alias */
export default NewslettersContext
